/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlayEvent200Response
 */
export interface PlayEvent200Response {
    /**
     * 
     * @type {number}
     * @memberof PlayEvent200Response
     */
    id: number;
}

/**
 * Check if a given object implements the PlayEvent200Response interface.
 */
export function instanceOfPlayEvent200Response(value: object): value is PlayEvent200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PlayEvent200ResponseFromJSON(json: any): PlayEvent200Response {
    return PlayEvent200ResponseFromJSONTyped(json, false);
}

export function PlayEvent200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayEvent200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function PlayEvent200ResponseToJSON(json: any): PlayEvent200Response {
    return PlayEvent200ResponseToJSONTyped(json, false);
}

export function PlayEvent200ResponseToJSONTyped(value?: PlayEvent200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

